module.exports = __webpack_public_path__ + "img/hut-6968718_1280.6ad7ae9f.png";